<template>
  <div class="page-home">
    <HomeBanner />
    <div class="container">
      <HomeCategory />
    </div>

    <!-- 最新课程 -->
    <HomeNew />
    <!-- 人气推荐课程 -->
    <HomeHot />
    <!-- 课程区域 -->
    <HomeLesson />
    <!-- 首页介绍 -->
    <HomeAbout />
  </div>
</template>
<script>
import HomeCategory from "./compontents/home-category";
import HomeBanner from "./compontents/home-banner";
import HomeNew from "./compontents/home-new";
import HomeHot from "./compontents/home-hot";
import HomeLesson from "./compontents/home-lesson";
import HomeAbout from "./compontents/home-about";
//import ShSkeleton from "@/components/library/sh-skeleton";

export default {
  name: "PageHome",
  components: {
    HomeCategory,
    HomeBanner,
    HomeNew,
    HomeHot,
    HomeLesson,
    HomeAbout,
  },
};
</script>
<style scoped lang="less"></style>
